// extracted by mini-css-extract-plugin
export default {"wrap":"ProductStatus_wrap__8grn4","line":"ProductStatus_line__8pb9V"};